import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import About from "@/components/About";
import EditorialMarquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import Gallery from "@/components/Gallery";
import Booking from "@/components/Booking";
import Footer from "@/components/Footer";

export default function Landing() {
  return (
    <div data-testid="landing-page">
      <Nav />
      <Hero />
      <About />
      <EditorialMarquee />
      <Manifesto />
      <Gallery />
      <Booking />
      <Footer />
    </div>
  );
}
